export default function BaseLayout({ children }) {
  return (
    <div
      className="base-layout-koohrokhi"
      dir="rtl"
      style={{ backgroundColor: "black" }}
    >
      {children}
    </div>
  );
}
